export default {
  setAuth: (state, payload) => { state.auth = payload },
  setCheck: (state, payload) => { state.checked = payload },
  setPending: (state, payload) => { state.pending = payload },
}